import { render, staticRenderFns } from "./WdcCampaignCustomerList.vue?vue&type=template&id=b66c86b6"
import script from "./WdcCampaignCustomerList.vue?vue&type=script&lang=js"
export * from "./WdcCampaignCustomerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports